import React from 'react';
import './style.scss';

function Spinner() {
  return (
    <div className="tv-loading__wrapper">
      <div className="tv-loading__content">
        <div className="tv-loading__spinner" />
      </div>
    </div>
  );
}

export default Spinner;
